import React, { useState } from 'react';
import PocketStyled from './bundle.esm2.js';
import { defaultFunction } from '../../utils/bundle.esm2.js';
import ChevronBottomSVG from '../../assets/images/pocket/bundle.esm.js';

const Pocket = (props) => {
  const { className, children, defaultOpened, isOpened: forceOpened } = props;
  const { title, icon, onChange = defaultFunction } = props;
  const [opened, setOpened] = useState(defaultOpened);
  const selectedIsOpened = forceOpened != null ? forceOpened : opened;
  const contentExtraClass = selectedIsOpened ? "Pocket__content--open" : "";
  const contentClasses = `Pocket__content ${contentExtraClass}`;
  const iconClass = !icon ? "Pocket__icon" : "";
  const iconClassRotate = selectedIsOpened ? "Pocket__icon--rotate" : "";
  const Icon = icon != null ? icon : ChevronBottomSVG;
  const onClick = (opened2) => {
    setOpened(opened2);
    onChange(opened2);
  };
  return /* @__PURE__ */ React.createElement(PocketStyled, {
    className: `Pocket ${className}`
  }, /* @__PURE__ */ React.createElement("header", {
    className: "Pocket__header",
    onClick: () => onClick(!selectedIsOpened)
  }, /* @__PURE__ */ React.createElement("div", {
    className: "Pocket__header__title"
  }, title), /* @__PURE__ */ React.createElement(Icon, {
    className: `${iconClass} ${iconClassRotate}`
  })), children ? /* @__PURE__ */ React.createElement("div", {
    className: contentClasses
  }, children) : null);
};
Pocket.defaultProps = {
  className: "",
  onChange: defaultFunction
};

export { Pocket as default };
//# sourceMappingURL=bundle.esm.js.map
